<template>
  <div>
    <!-- 添加客户 -->
    <el-drawer v-model="open" :title="title" :size="880"
               modal-class="digital_buyer-7146"
               :show-close="false"
               @open="openDrawer">
      <el-form ref="formRef" :model="formData" label-position="top">
        <el-row>
          <el-col>
            <el-form-item label="客户分类" prop="categoryName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="formData.categoryName" :readonly="true" style="width: 240px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="客户名称" prop="name" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model.trim="formData.name" placeholder="请输入" @blur="blur" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="统一社会信用代码" prop="taxRegistrationNo">
              <el-input v-model.trim="formData.taxRegistrationNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="简码" prop="shortCode">
              <el-input v-model.trim="formData.shortCode" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="basic">
          <div class="basic_wrap" v-for="(item, index) in formData.bankInfoList" :key="index">
            <div class="basic_wrap_head">
              <el-space :size="10">
                <span style="font-size: 14px; font-weight: 600; color: #333"> 地址电话及银行({{ index + 1 }} ) </span>
                <el-button type="danger" link style="font-size: 12px" @click="deleteBank(index)">删除</el-button>
              </el-space>
              <el-space :size="10">
                <span style="font-size: 12px; color: #999">设为默认</span>
                <el-switch v-model="item.isDefault" size="small" :active-value="1" :inactive-value="0" @change="(val) => changeSwitch(val, index)" />
              </el-space>
            </div>

            <el-row :gutter="10" style="margin-top: 20px">
              <el-col :span="16">
                <el-form-item label="地址" prop="address">
                  <el-input v-model.trim="item.address" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话" prop="phone">
                  <el-input v-model.trim="item.phone" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top: 20px">
              <el-col :span="8">
                <el-form-item label="开户行" prop="bank">
                  <el-input v-model.trim="item.bank" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号" prop="account">
                  <el-input v-model.trim="item.account" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系邮箱" prop="email">
                  <el-input v-model.trim="item.email" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div class="plus">
        <el-button type="default" icon="plus" size="large" @click="addBank">添加地址及银行信息</el-button>
      </div>
      <template #footer>
        <el-button type="primary" @click="confirmBuyer">确定</el-button>
        <el-button type="default" @click="open = false">取消</el-button>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { pinyin } from 'pinyin-pro';
import useInvoiceStore from '@/store/modules/invoice';

const useInvoice = useInvoiceStore();
const props = defineProps({
  row: {
    type: Object,
    default: () => ({}),
  },
});

const emits = defineEmits(['refresh']);
const open = defineModel({ type: Boolean, default: false });
const title = ref('');

const formData = ref({});
const formRef = ref();

function openDrawer() {
  title.value = props.row?.id ? '修改' : '添加';
  nextTick(() => {
    formRef.value && formRef.value.resetFields();
    formData.value = Object.assign({}, props.row);
    if (!formData.value?.bankInfoList?.length) {
      formData.value.bankInfoList = [
        {
          address: undefined,
          phone: undefined,
          bank: undefined,
          account: undefined,
          email: undefined,
          isDefault: 1,
        },
      ];
    }
  });
}

function blur(e) {
  if (e.target.value) {
    const text = pinyin(e.target.value, { pattern: 'first', type: 'array' }).join('');
    formData.value.shortCode = text.toLocaleUpperCase();
  } else {
    formData.value.shortCode = undefined;
  }
}

//点击删除按钮
function deleteBank(index) {
  formData.value.bankInfoList.splice(index, 1);
}

//点击添加地址及银行信息
function addBank() {
  if (!formData.value?.bankInfoList?.length) formData.value.bankInfoList = [];
  formData.value.bankInfoList.push({
    address: undefined,
    phone: undefined,
    bank: undefined,
    account: undefined,
    email: undefined,
    isDefault: 0,
  });
}

//设置默认
function changeSwitch(val, index) {
  if (val === 1) {
    formData.value.bankInfoList.forEach((item) => {
      item.isDefault = 0;
    });
    formData.value.bankInfoList[index].isDefault = val;
  }
}

function confirmBuyer() {
  formRef.value &&
    formRef.value.validate((valid) => {
      if (valid) {
        if (!formData.value.id) {
          useInvoice.addBuyer(formData.value);
        } else {
          useInvoice.updateBuyer(formData.value);
        }
        open.value = false;
        emits('refresh');
      }
    });
}
</script>

<style lang="scss" scoped>
:deep(.el-drawer) {
  .el-drawer__header {
    height: 50px;
    line-height: 50px;
    padding: 0;
    padding-left: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
  }
  .el-drawer__body {
    .basic {
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: 20px;
      display: flex;
      flex-direction: column;
      row-gap: 40px;
      .basic_wrap {
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
        background-color: #f9fafd;
        .basic_wrap_head {
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .plus {
      box-sizing: border-box;
      width: 100%;
      padding: 20px 0;
      text-align: center;
      > .el-button {
        margin: 0 auto;
        border: 1px dashed #ddd;
      }
    }
  }
  .el-drawer__footer {
    border-top: 1px solid #eee;
    text-align: start;
  }
}
</style>

<style lang="scss">
.digital_buyer-7146 {
  pointer-events: none;
  .el-drawer {
    pointer-events: auto;
  }
  &.el-overlay {
    background-color: transparent;
  }
}
</style>
